// @ts-ignore
import fetchGitRepo from 'fetch-git-repo-async';
import fse from 'fs-extra';
import path from 'path';

import {getConfigOrExit} from '@/utilities/config';

export const cloneKreateTemplate = async (currentWorkingDirectory: string = process.cwd()) => {
  const config = await getConfigOrExit();
  return fetchGitRepo(`direct:${process.env.GITLAB_URL_KREATE}`, currentWorkingDirectory, {
    headers: {'PRIVATE-TOKEN': config.gitlabToken},
  });
};

export const cloneBlankTemplate = async (currentWorkingDirectory: string = process.cwd()) => {
  const currentWorkingDirectoryPath = path.resolve(currentWorkingDirectory);
  return fse.outputFileSync(`${currentWorkingDirectoryPath}/README.md`, '# Blank Template', 'utf8');
};

export const clonePackageTemplate = async (currentWorkingDirectory: string = process.cwd()) => {
  const currentWorkingDirectoryPath = path.resolve(currentWorkingDirectory);
  return fse.outputFileSync(`${currentWorkingDirectoryPath}/package.json`, '{"name": "cd-kog", "version": "1.0.0"}', 'utf8');
};

export const cloneKogFiles = async (componentName: string, currentWorkingDirectory: string = process.cwd()) => {
  const config = await getConfigOrExit();
  const currentWorkingDirectoryPath = path.resolve(currentWorkingDirectory);
  return fetchGitRepo(`direct:${process.env.GITLAB_URL_KOG_ZIP}?path=src/${componentName}`, currentWorkingDirectoryPath, {
    headers: {'PRIVATE-TOKEN': config.gitlabToken},
  });
};
